const PROVIDERS = [
  { key: "openai", label: "OpenAI", color: "#00F2FE" },
  { key: "claude", label: "Claude", color: "#A855F7" },
  { key: "gemini", label: "Gemini", color: "#EC4899" },
  { key: "perplexity", label: "Perplexity", color: "#14B8A6" },
];

const STEP_LABEL = {
  pending: "Queued",
  scanning: "Probing AI Models",
  analyzing: "Running Hallucination Detection",
  complete: "Complete",
  failed: "Failed",
};

export const ProbeProgress = ({ status }) => {
  const active = status === "scanning" || status === "analyzing";
  return (
    <div className="w-full max-w-md" data-testid="probe-progress">
      <div className="mb-6 flex items-center justify-center gap-2">
        <div className={`h-2 w-2 rounded-full bg-sovereign ${active ? "pulse-dot" : ""}`} />
        <span className="text-sm font-medium text-slate-300">{STEP_LABEL[status] || "Initializing"}</span>
      </div>
      <div className="space-y-4">
        {PROVIDERS.map((p, i) => (
          <div key={p.key} className="fade-up" style={{ animationDelay: `${i * 120}ms` }}>
            <div className="mb-1 flex items-center justify-between text-xs">
              <span className="font-medium" style={{ color: p.color }}>{p.label}</span>
              <span className="text-slate-500">{status === "complete" ? "Done" : status === "pending" ? "Waiting" : "Querying..."}</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-surface-border">
              <div
                className="h-full rounded-full transition-all duration-1000"
                style={{
                  width: status === "complete" ? "100%" : status === "pending" ? "5%" : "70%",
                  backgroundColor: p.color,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
